import {Form, Input, Checkbox, Button, Flex} from "antd";
import {UserOutlined, MailOutlined, LockOutlined} from "@ant-design/icons"
import { Link } from "react-router-dom";

const LoginForm = () => {


  return (
    <>
        <Form.Item
        name="email"
        rules={[
          {
            type: 'email',
            message: 'The input is not valid E-mail!',
          },
          {
            required: true,
            message: 'Please input your E-mail!',
          },
        ]}
      >
        <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="email" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: 'Please input your Password!',
          },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined className="site-form-item-icon" />}
          placeholder="Password"
        />
      </Form.Item>
      <Form.Item>
        <Form.Item name="remember" valuePropName="checked" noStyle>
          <Checkbox>Remember me</Checkbox>
        </Form.Item>

        <Link to="../forget-password">
          Forgot password
        </Link>
      </Form.Item>

        <Flex justify="center" gap="large">
        <Button type="primary" htmlType="submit" className="login-form-button">
          Log in
        </Button>
        Or <Link to="../registration">register now!</Link>
        </Flex>
    </>
  );
};

export default LoginForm;
